module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACcSURBVEhL7dJNCoJQFIbhuwhHQXPX44qizTgI2kPOo41EYY37eb+Bl5Md0GsGQfeFZyDnehQx5HJf7fGhC2JX2KGy11McENvCDpW9nmKFWIkTuqGyh1O1KPDSEhtoqLwbx7ijwmDezUPOGLVceQs8+lv2WOPts/xU/TefvdkfsECNI/rLO5rpjM4m18Bb6tkhuRu8ZR6dzf1nITwBW+6g5tmOsDwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-metal/dark/24.png
// module id = 2244
// module chunks = 2